import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const manageStorePayment = createAsyncThunk(
  "/add/managePayment",
  async ({ id, add }) => {
    try {
      const myurl = id
        ? `${V_URL}/user/manage-payment-method/${id}`
        : `${V_URL}/user/manage-payment-method`;

      const response = await axios({
        method: "post",
        url: myurl,
        data: add,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
        },
      });

      const payment = response.data;

      if (payment.success === true) {
        toast.success(payment?.message);
        return payment;
      } else {
        throw new Error(payment);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      return error;
    }
  }
);

const manageStorePaymentSlice = createSlice({
  name: "managePayment",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manageStorePayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manageStorePayment.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(manageStorePayment.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default manageStorePaymentSlice.reducer;
